import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useReducer } from "@wordpress/element";
import { reducer } from "../reducers/loading-reducer";
const initialState = {
    fullPageLoading: false,
};
const LoadingContext = createContext({
    state: initialState,
    loadingDispatch: () => { },
});
const LoadingContextProvider = ({ children, }) => {
    const [state, loadingDispatch] = useReducer(reducer, initialState);
    return (_jsx(LoadingContext.Provider, { value: { state, loadingDispatch }, children: children }));
};
export { LoadingContext, LoadingContextProvider };
